import {
  HStack,
  Link,
  Table,
  TableContainer,
  Tbody,
  Td,
  Tr,
} from "@chakra-ui/react";
import { useInvestorTransferDocumentsListSuspense } from "gen/endpoints/investor-transfer/investor-transfer";
import { useTranslation } from "react-i18next";
import EmptyState from "shared/components/empty/EmptyState";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTitle } from "shared/components/table/box/TableBoxTitle";
import { FileDownload3Icon } from "shared/icons/FileDownload3Icon";

export interface InvestorTransferReviewDocumentsTableProps {
  fundFamilyId: string;
  investorTransferId: string;
}

export const InvestorTransferReviewDocumentsTable: React.FC<
  InvestorTransferReviewDocumentsTableProps
> = ({ fundFamilyId, investorTransferId }) => {
  const { t } = useTranslation(["investorTransfer"]);

  const { data: listData } = useInvestorTransferDocumentsListSuspense(
    fundFamilyId,
    investorTransferId,
  );

  const isTableEmpty = listData.length === 0;

  const tableContent = isTableEmpty ? (
    <EmptyState
      title={t("investorTransfer:setup.review.documentsTable.empty.title")}
      description={t(
        "investorTransfer:setup.review.documentsTable.empty.description",
      )}
    />
  ) : (
    <TableContainer height="100%" overflowY="auto">
      <Table>
        <Tbody>
          {listData.map((item) => (
            <Tr key={item.id}>
              <Td>
                <HStack spacing="8px">
                  <FileDownload3Icon display="inline-block" />
                  <Link href={item.url} color="unset">
                    {item.filename}
                  </Link>
                </HStack>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );

  return (
    <TableBox>
      <TableBoxHeader>
        <TableBoxTitle>
          {t("investorTransfer:setup.review.documentsTable.title")}
        </TableBoxTitle>
      </TableBoxHeader>
      <TableBoxBody>{tableContent}</TableBoxBody>
    </TableBox>
  );
};
